import React from "react";
import { Route } from "react-router-dom";
import WalletScreen from "../../screens/WalletScreen";
import CreateWarehouse from "../../screens/land/CreateWarehouse";
import CreateStorage from "../../screens/supply_chain/CreateStorage";

export const storageRoutes = [
  <Route
    key="storage-warehouses"
    path="/warehouses"
    element={<WalletScreen walletType="WAREHOUSELAND" />}
  />,
  <Route
    key="storage-create-warehouse-land"
    path="/create-warehouse-land"
    element={<CreateWarehouse />}
  />,
  <Route
    key="storage-storage"
    path="/storage"
    element={<WalletScreen walletType="STORAGE" />}
  />,
  <Route
    key="storage-create-storage"
    path="/create-storage"
    element={<CreateStorage />}
  />,
];
